module.exports = function getResource(label, vars = []) {
    let resources = {
        selectShoppingExperience: 'Select shopping experience',
        unitedStates: 'United States'
    };
    return resources[label];
};
